export default __webpack_public_path__ + "static/media/notification-bell.49926fe9.svg";